import { TimelineIndex } from '../GalleryView/timelineIndex'

export interface YearMark {
  key: string
  /** 0..1 position along the rail */
  topFraction: number
  /** false → rendered as a dot instead of a label */
  showLabel: boolean
}

/** matches gallery desktop defaults; only used for a rough visibility estimate */
const ESTIMATE_ROW_HEIGHT = 248
const ESTIMATE_ITEMS_PER_ROW = 4
const MIN_VIEWPORT_MULTIPLE = 2.5
const MIN_LABEL_SPACING_PX = 28

export const estimateContentHeight = (totalItems: number): number =>
  (totalItems / ESTIMATE_ITEMS_PER_ROW) * ESTIMATE_ROW_HEIGHT

export const shouldShowScrubber = (totalItems: number, viewportHeight: number): boolean =>
  totalItems > 0 && estimateContentHeight(totalItems) >= MIN_VIEWPORT_MULTIPLE * viewportHeight

export const computeYearMarks = (
  timeline: TimelineIndex,
  railHeight: number,
  minLabelSpacing: number = MIN_LABEL_SPACING_PX
): Array<YearMark> => {
  if (timeline.total === 0 || railHeight <= 0) return []

  let lastLabelY = -Infinity
  return timeline.years.map((year) => {
    const topFraction = year.itemsBefore / timeline.total
    const y = topFraction * railHeight
    const showLabel = y - lastLabelY >= minLabelSpacing
    if (showLabel) lastLabelY = y
    return { key: year.key, topFraction, showLabel }
  })
}
